import React from 'react'
import { Avatar, Box, Container, Stack } from '@mui/material'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import styled from '@emotion/styled';
import { customStyles } from '../../styles';
import { Navbar } from '../../navbar/Navbar';
import { useNavigate } from 'react-router-dom';
import { animations } from '../../utils/animations';
import { useEffect, useRef, useState } from 'react';
import logo from '../../assets/images/logo.png'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { MobileMenu } from './MobileMenu';
import { DeskMenu } from './DeskMenu';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { getInfo } from '../../actions/infoAction';
const image = "https://thumbs.dreamstime.com/b/businessman-icon-vector-male-avatar-profile-image-profile-businessman-icon-vector-male-avatar-profile-image-182095609.jpg" //TEMP
export const Header = () => {
  const { colors: { red }, containers: { large } } = customStyles
  const CustomNotification = styled(NotificationsNoneIcon)(() => (({
    color: red
  })))
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [token] = useLocalStorage('login-token', null)
  const { socialNetworks } = useSelector(state => state.info)
  const fetchedInfoRef = useRef(false)

  useEffect(() => {
    if (token?.token && !socialNetworks && !fetchedInfoRef.current) {
      fetchedInfoRef.current = true
      // El `finally` libera el ref al terminar (haya fallado o no): si tuvo éxito,
      // la guarda `!socialNetworks` ya evita un refetch; si falló, permite reintentar.
      dispatch(getInfo(token.token)).finally(() => {
        fetchedInfoRef.current = false
      })
    }
  }, [token?.token])
  const handleNavigate = () => {
     navigate(`/dashboard/settings`)
  }
  const [notification, setNotification] = useState(false)
  const handleNotification = () => {
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 500);
  }
  return (
    <Stack width="100%" direction="row" justifyContent="center" mb={2}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" pl={1}>
        <img src={logo} alt="global gas" style={{
          width: 40,
        }}/>
        <Stack direction="row" alignItems="center" justifyContent="space-between" >
          {/* <Navbar /> */}
          {/* <CustomNotification className={ notification ? animations.ruber : ''} onClick={handleNotification} sx={{ cursor: 'pointer' }}/> */}
          {/* <Avatar src={ image }alt="profile" onClick={handleNavigate}/> */}
          <DeskMenu />
          <MobileMenu />
        </Stack>
      </Stack>
    </Stack>
  )
}
